<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <vs-spacer />

        <notifications-bell v-if="!hideNotificationBell" class="mr-4" />

        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>


<script>
  import ProfileDropDown      from "./components/ProfileDropDown.vue"
  import NotificationsBell    from "@/components/approvals/NotificationsBell.vue"

  import moduleUser from '@/store/user/moduleUser.js'

  import user from '@/http/requests/user'

  export default {
    name: "the-navbar-vertical",
    props: {
      navbarColor: {
        type: String,
        default: '#fff'
      }
    },
    data() {
      return {
        userStatus: false
      }
    },
    watch: {
      userStatus(val) {
        if (val) {
          return user.connected()
        }

        return user.disconnected()
      }
    },
    components: {
      ProfileDropDown,
      NotificationsBell,
    },
    computed: {
      navbarColorLocal() {
        if (this.$store.state.theme === "dark" && this.navbarColor === "#fff") {
          return '#10163a'
        }

        return this.navbarColor
      },
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      textColor() {
        return {
          'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
        }
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      isOriginBackoffice(){
        return process.env.VUE_APP_ORIGIN_BACKOFFICE && process.env.VUE_APP_ORIGIN_BACKOFFICE === 'true'
      },
      hideNotificationBell(){
        if (!this.isOriginBackoffice || this.$route.path.includes('two-factor')) {
          return true
        }
        if (localStorage.getItem('twoFactor') === 'true' && !localStorage.getItem('accessToken')) {
          return true
        }
        const email = localStorage.getItem('email')
        const users = this.$store.state.users && this.$store.state.users.users
        if (email && users && users.length) {
          const userData = users.find((user) => user.email === email)
          if (userData && userData.twofactor_activity === true && userData.is_two_factor_validated === false) {
            return true
          }
        }
        return false
      },
      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth === 'default') {
          return "navbar-default"
        }

        if (this.verticalNavMenuWidth === 'reduced') {
          return "navbar-reduced"
        }

        if (this.verticalNavMenuWidth) {
          return "navbar-full"
        }
      }
    },
    created() {
      this.$vs.loading.close();
      const that = this
      setTimeout(function() {
        that.$vs.loading.close();
      }, 100)
    },
    methods: {
      showSidebar() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  }
</script>
